<div class="grid device-diagnostics">
  <div class="col-12">
    <h2 class="page-title">Device Diagnostics</h2>
  </div>

  <div class="col-12 action-container">
    <button pButton type="button" (click)="refresh()" [disabled]="loading">
      <i pButtonIcon class="fa fa-sync"></i>
      <span pButtonLabel>Refresh</span>
    </button>
  </div>

  @if (lastUpdated) {
    <div class="col-12 meta">
      <span>Last updated {{ lastUpdated | date:'short' }}</span>
    </div>
  }

  <div class="col-12">
    <p-table #dt [value]="rows" [loading]="loading" [paginator]="false" sortField="utcTimestamp" [sortOrder]="-1">
      <ng-template #header>
        <tr>
          <th pSortableColumn="deviceName">Device<p-sortIcon field="deviceName"></p-sortIcon></th>
          <th>Device Id</th>
          <th pSortableColumn="measurementName">Measurement<p-sortIcon field="measurementName"></p-sortIcon></th>
          <th pSortableColumn="utcTimestamp">Timestamp<p-sortIcon field="utcTimestamp"></p-sortIcon></th>
          <th>Value</th>
          <th>Tags</th>
        </tr>
        <tr class="filters">
          <th></th>
          <th>
            <input pInputText type="text" class="filter-input" placeholder="Search device id"
              (input)="dt.filter($event.target.value, 'deviceId', 'contains')">
            </th>
            <th>
              <input pInputText type="text" class="filter-input" placeholder="Search measurement"
                (input)="dt.filter($event.target.value, 'measurementName', 'contains')">
              </th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template #body let-row>
            <tr>
              <td>{{ row.deviceName }}</td>
              <td>{{ row.deviceId }}</td>
              <td>{{ row.measurementName }}</td>
              <td>{{ row.timestampDisplay }}</td>
              <td>{{ row.valueDisplay }}</td>
              <td class="tags-cell">{{ row.tagsSummary || '—' }}</td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td colspan="6">No recent measurements found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
